import React from "react";
import { Row, Col, Form } from "react-bootstrap";
import { autoFormatNPWP, onlyDigits } from "../utils/registerUtils.js";

// Checklist validasi NPWP
const ChecklistValidasiNPWP = ({ npwp }) => {
    const digits = (npwp || "").replace(/\D/g, ""); // ambil angka saja
    const isValid = digits.length === 16;
    const is15 = digits.length === 15;

    return (
        <ul className="list-unstyled mt-2 mb-1">
            <li className={isValid ? "text-success" : "text-danger"}>
                {isValid ? "✔" : "✖"} NPWP harus 16 digit (saat ini {digits.length} digit)
            </li>
            {is15 && (
                <li className="text-warning">
                    ⚠ NPWP Anda masih 15 digit. Tambahkan angka <strong>0</strong> di depan NPWP agar menjadi 16 digit.
                </li>
            )}
        </ul>
    );
};

const TraderForm = ({
    trader, setTrader,
    trade, tradeFound,
    propinsi, kota,
    files, setFiles,
    handleNPWPBlur,
    handlePropinsiChange,
}) => {
    const val = (traderVal, tradeVal) => (tradeFound ? tradeVal : traderVal);
    const disabled = tradeFound;

    return (
        <>
            {/* NPWP */}
            <Form.Group as={Row} className="form-group">
                <Form.Label column sm="3" className="control-label align-self-center mb-0 text-dark">
                    NPWP Perusahaan*
                </Form.Label>
                <Col sm="4">
                    <Form.Control
                        type="text"
                        pattern=".{21}"
                        maxLength="21"
                        placeholder="NPWP Perusahaan 16 Digit"
                        required
                        value={trader.NPWP || ""}
                        onChange={(e) => setTrader({ ...trader, NPWP: e.target.value })}
                        onBlur={handleNPWPBlur}
                        onInput={(e) => { e.target.value = autoFormatNPWP(e.target.value); }}
                    />
                    <ChecklistValidasiNPWP npwp={trader.NPWP} />
                </Col>
                <Col sm="5">
                    <Form.Control
                        type="file"
                        accept=".pdf,.png,.jpg,.jpeg"
                        onChange={(e) => setFiles((f) => ({ ...f, npwp: e.target.files[0] }))}
                    />
                </Col>
            </Form.Group>

            {/* Nama Perusahaan */}
            <Form.Group as={Row} className="form-group">
                <Form.Label column sm="3" className="control-label align-self-center mb-0">
                    Nama Perusahaan*
                </Form.Label>
                <Col sm="9">
                    <Form.Control
                        type="text"
                        placeholder="Nama Perusahaan"
                        value={val(trader.NAMA, trade?.NAMA) || ""}
                        disabled={disabled}
                        onChange={(e) => setTrader({ ...trader, NAMA: e.target.value })}
                        required
                    />
                </Col>
            </Form.Group>

            {/* NIB */}
            <Form.Group as={Row} className="form-group">
                <Form.Label column sm="3" className="control-label align-self-center mb-0 text-dark">
                    Nomor Induk Berusaha (NIB)
                </Form.Label>
            </Form.Group>
            <Form.Group as={Row} className="form-group">
                <Form.Label column sm="3" className="control-label align-self-center mb-0 ps-5">
                    Nomor*
                </Form.Label>
                <Col sm="4">
                    <Form.Control
                        type="text"
                        inputMode="numeric"
                        pattern="\d{13}"
                        maxLength="13"
                        placeholder="Nomor izin usaha (13 digit)"
                        value={val(trader.NO_IZIN, trade?.NO_IZIN) || ""}
                        disabled={disabled}
                        onChange={(e) => setTrader({ ...trader, NO_IZIN: onlyDigits(e.target.value) })}
                        title="NIB harus 13 digit angka"
                        required
                    />
                </Col>
                <Col sm="5">
                    <Form.Control
                        type="file"
                        accept=".pdf,.png,.jpg,.jpeg"
                        onChange={(e) => setFiles((f) => ({ ...f, nib: e.target.files[0] }))}
                    />
                </Col>
            </Form.Group>

            {/* Alamat Kantor */}
            <Form.Group as={Row} className="form-group">
                <Form.Label column sm="3" className="control-label align-self-center mb-0 text-dark">
                    Alamat Kantor
                </Form.Label>
            </Form.Group>
            <Form.Group as={Row} className="form-group">
                <Form.Label column sm="3" className="control-label align-top mb-0 ps-5">
                    Jalan / No / Rt / Rw
                </Form.Label>
                <Col sm="9">
                    <Form.Control
                        as="textarea"
                        rows="3"
                        placeholder="Alamat Kantor"
                        value={val(trader.ALAMAT, trade?.ALAMAT) || ""}
                        disabled={disabled}
                        onChange={(e) => setTrader({ ...trader, ALAMAT: e.target.value })}
                        required
                    />
                </Col>
            </Form.Group>

            {/* Propinsi */}
            <Form.Group as={Row} className="form-group">
                <Form.Label column sm="3" className="control-label align-self-center mb-0 ps-5">
                    Propinsi*
                </Form.Label>
                <Col sm="9">
                    <select
                        className="form-select mb-3 shadow-none"
                        value={val(trader.PROPINSI, trade?.PROPINSI) || ""}
                        disabled={disabled}
                        onChange={handlePropinsiChange}
                        required
                    >
                        <option value="">Pilih Propinsi</option>
                        {propinsi.map((item) => (
                            <option key={item.KODE_PROPINSI} value={item.KODE_PROPINSI}>
                                {item.URAIAN_PROPINSI}
                            </option>
                        ))}
                    </select>
                </Col>
            </Form.Group>

            {/* Kota */}
            <Form.Group as={Row} className="form-group">
                <Form.Label column sm="3" className="control-label align-self-center mb-0 ps-5">
                    Kabupaten / Kota*
                </Form.Label>
                <Col sm="9">
                    <select
                        className="form-select mb-3 shadow-none"
                        value={val(trader.KOTA, trade?.KOTA) || ""}
                        disabled={disabled}
                        onChange={(e) => setTrader({ ...trader, KOTA: e.target.value })}
                        required
                    >
                        <option value="">Pilih Kabupaten/Kota</option>
                        {kota.map((item) => (
                            <option key={item.KODE_KOTA} value={item.KODE_KOTA}>
                                {item.URAIAN_KOTA}
                            </option>
                        ))}
                    </select>
                </Col>
            </Form.Group>

            {/* Kode Pos */}
            <Form.Group as={Row} className="form-group">
                <Form.Label column sm="3" className="control-label align-self-center mb-0 ps-5">
                    Kode Pos
                </Form.Label>
                <Col sm="9">
                    <Form.Control
                        type="text"
                        placeholder="Kode Pos"
                        value={val(trader.KODEPOS, trade?.KODEPOS) || ""}
                        disabled={disabled}
                        onChange={(e) => setTrader({ ...trader, KODEPOS: e.target.value })}
                    />
                </Col>
            </Form.Group>

            {/* Telepon Kantor */}
            <Form.Group as={Row} className="form-group">
                <Form.Label column sm="3" className="control-label align-self-center mb-0 ps-5">
                    Telepon / Faksimili
                </Form.Label>
                <Col sm="9">
                    <Form.Control
                        type="text"
                        placeholder="Telepon Kantor"
                        value={val(trader.TELEPON, trade?.TELEPON) || ""}
                        disabled={disabled}
                        onChange={(e) => setTrader({ ...trader, TELEPON: e.target.value })}
                    />
                </Col>
            </Form.Group>

            {/* Email Kantor */}
            <Form.Group as={Row} className="form-group">
                <Form.Label column sm="3" className="control-label align-self-center mb-0 ps-5">
                    Pos Elektronik / Email*
                </Form.Label>
                <Col sm="9">
                    <Form.Control
                        type="email"
                        placeholder="Email Kantor"
                        value={val(trader.EMAIL, trade?.EMAIL) || ""}
                        disabled={disabled}
                        onChange={(e) => setTrader({ ...trader, EMAIL: e.target.value.trim() })}
                        pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
                        title="Masukkan format email yang valid, contoh: nama@domain.com"
                        required
                    />
                </Col>
            </Form.Group>

            {/* Keterangan */}
            <Form.Group as={Row} className="form-group">
                <Form.Label column sm="3" className="control-label align-top mb-0 ps-5">
                    Keterangan
                </Form.Label>
                <Col sm="9">
                    <Form.Control
                        as="textarea"
                        rows="3"
                        placeholder="Keterangan"
                        value={val(trader.KETERANGAN, trade?.KETERANGAN) || ""}
                        disabled={disabled}
                        onChange={(e) => setTrader({ ...trader, KETERANGAN: e.target.value })}
                    />
                </Col>
            </Form.Group>
        </>
    );
};

export default TraderForm;